import { twMerge } from '@panwds/tailwindcss';
export function styleIcon({ size = 'md', viewBox, ariaHidden = true, ariaLabel, className, focusable = false, role = 'img', ...passThrough }) {
    return {
        'aria-label': ariaLabel,
        'aria-hidden': ariaHidden,
        className: twMerge('twds-fill-current', className),
        focusable,
        height: `${iconSizes[size]}px`,
        width: `${iconSizes[size]}px`,
        role,
        viewBox,
        ...passThrough
    };
}
const iconSizes = {
    xxs: 10,
    xs: 12,
    sm: 14,
    md: 16,
    lg: 20,
    xl: 24,
    xxl: 28,
    '3xl': 32,
    '4xl': 40,
    '5xl': 48
};
//# sourceMappingURL=style_icon.js.map